import { Header0, Header2, Paragraph1, useDeviceType } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './Layout.css';
import { Hero } from './components/Hero';

interface ILayoutProps {
  calculator: React.ReactElement;
}

export const Layout: React.FC<ILayoutProps> = ({ calculator }) => {
  const deviceType = useDeviceType();
  const Header = deviceType === 'phone' ? Header2 : Header0;

  return (
    <div className={cx(styles['container'], styles[`container--${deviceType}`])}>
      <div className={styles['sidebar']}>
        <Hero />
        <div className={styles['sidebar-content']}>
          <div className={styles['sidebar-header']}>
            <Header as="h1">Калькулятор &laquo;Копить&nbsp;или&nbsp;купить&raquo;</Header>
          </div>
          <Paragraph1>
            Подскажет, как выгоднее купить квартиру: взять в ипотеку или копить деньги, пока снимаешь
          </Paragraph1>
        </div>
      </div>
      <div className={styles['calculator-wrapper']}>
        <div className={styles['calculator']}>{calculator}</div>
      </div>
    </div>
  );
};
